// T-195 (v1.8.66): gesperrten Browser-Speicher vor allen anderen Modulen durch einen Arbeitsspeicher ersetzen (erster Import)
import './speicherAbsicherung';
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import NaechsteTermine from './pages/NaechsteTermine';
import reportWebVitals from './reportWebVitals';
import { setupAxiosAuthInterceptor } from './config/axiosAuthInterceptor';

// T-009 (28.08.2026): automatischer 401-Token-Refresh fuer alle axios-Aufrufe
setupAxiosAuthInterceptor();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
// T-190 (v1.8.64): die Terminliste /termine (zum Einbetten auf frankenfloss.de) läuft ohne AuthProvider, PaymentProvider und
// VersionWatcher. Im eingebetteten Fenster kann der Browser den Speicher sperren (Drittanbieter-Cookies blockiert, privates
// Fenster); jeder Zugriff würde sonst die ganze Anwendung abbrechen (Review v1.8.64). Die Liste selbst nutzt keinen Speicher.
const nurTerminliste = window.location.pathname.replace(/\/+$/, '').toLowerCase() === '/termine';
root.render(
  <React.StrictMode>
    {nurTerminliste ? <NaechsteTermine /> : <App />}
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
